module.exports = __webpack_public_path__ + "img/img_kong.f7460875.png";